import { useMemo, useState } from "react";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { searchNace } from "@/lib/lead-segment";

interface NaceCodePickerProps {
  value: string[];
  onChange: (codes: string[]) => void;
}

/** Søk i SN2007-næringskoder (kode eller navn) og legg dem til som merker. */
export default function NaceCodePicker({ value, onChange }: NaceCodePickerProps) {
  const [query, setQuery] = useState("");
  const results = useMemo(() => searchNace(query).filter((r) => !value.includes(r.code)), [query, value]);

  const add = (code: string) => {
    onChange([...value, code]);
    setQuery("");
  };

  return (
    <div className="space-y-2">
      <Input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Søk bransje, f.eks. «restaurant» eller 56.101"
        aria-label="Søk næringskode"
      />
      {results.length > 0 && (
        <ul className="max-h-44 overflow-y-auto border border-border" aria-label="Treff på næringskode">
          {results.map((r) => (
            <li key={r.code}>
              <button
                type="button"
                className="flex w-full gap-2 px-3 py-1.5 text-left text-sm hover:bg-muted"
                onClick={() => add(r.code)}
              >
                <span className="font-mono text-xs text-muted-foreground">{r.code}</span>
                <span>{r.name}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {value.map((code) => (
            <Badge key={code} variant="secondary" className="gap-1">
              {code}
              <button type="button" aria-label={`Fjern ${code}`} onClick={() => onChange(value.filter((c) => c !== code))}>
                ×
              </button>
            </Badge>
          ))}
        </div>
      )}
    </div>
  );
}
